module.exports = (
	{
		"Metadata": {
			"UUID": false,
			"Hash": false,

			"Name": "",
			"Summary": "",

			"Version": 0
		},
		"Status": {
			"Completed": false,
			"StepCount": 1
		},
		"Steps": [],
		"Errors": [],
		"Log": []
	}
);